// @flow
/*global location*/
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import CubeSpiner from '../../spiners/CubeSpiner';

const ErrorLoading = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: red;
`;

const QrModalOverlay = styled.div`
  background: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`;

const QrModalContent = styled.div`
  background: white;
  padding: 10px;
  color: black;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10000;
  transform: translate(-50%);
`;

class QrButton extends PureComponent {
  state = {
    isOpen: false,
  }

  props: {
    children: React$Element<any>,
  }

  toggleOpen = () => {
    if (!this.state.isOpen && !this.state.qrImage) {
      this.setState({
        isLoading: true,
      });
      const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${window.location.href}`
      const img = new Image();
      img.src = qrSrc;
      img.onload = () => {
        this.setState({
          qrImage: qrSrc,
          error: false,
          isLoading: false,
        });
      }
      img.onerror = () => {
        this.setState({
          error: true,
        });
      }
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <span onClick={this.toggleOpen} role="presentation">
        {this.state.isOpen && (
          <div>
            <QrModalOverlay onClick={this.toggleOpen} />
            <QrModalContent>
              {this.state.qrImage && <img src={this.state.qrImage} alt="Qr code" />}
              {this.state.isLoading && (
                <CubeSpiner width={150} height={150} />
              )}
              {this.state.error && <ErrorLoading>Error cargando qr</ErrorLoading>}
            </QrModalContent>
          </div>
        )}
        {this.props.children}
      </span>
    );
  }
}

export default QrButton;



// WEBPACK FOOTER //
// ./src/components/Navbar/QrButton/index.js